import { Component, computed, inject } from '@angular/core';
import { LayoutService } from '../../services/LayoutService';
import { Button } from 'primeng/button';
import { Avatar } from 'primeng/avatar';
import { Menu } from 'primeng/menu';
import { AuthService, USER_ROLE_OWNER, USER_ROLE_MANAGER, USER_ROLE_EMPLOYEE } from '../../services/AuthService';
import { TranslocoService } from '@jsverse/transloco';
import { LocationSwitcher } from './location-switcher';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-top-bar',
  template: `
      <div class="h-14 flex flex-row px-4 justify-between bg-surface-0 dark:bg-surface-900">
        <div class="flex gap-4 items-center">
          <p-button variant="text" severity="contrast" class="sm:hidden" (click)="layoutService.toggleMobileMenu()">
            <i class="pi pi-bars" style="font-size: 1.5rem"></i>
          </p-button>
          <h1 class="text-2xl font-light">
            {{ auth.user()?.company?.name }}
            @if(auth.currentLocations().length === 1) {
              <span class="text-xl opacity-60 ml-2">/ {{ auth.currentLocations()[0].name }}</span>
            }
          </h1>
          @if(false) {
            <app-location-switcher class="hidden sm:block"/>
          }
        </div>
        <div class="flex sm:gap-4 items-center">
          <div class="cursor-pointer flex flex-row gap-3" (click)="usermenu.toggle($event)">
            <p-avatar [label]="auth.initials()"></p-avatar>
            <div class="flex-col hidden sm:flex">
              <div>{{ auth.user()?.first_name }} {{ auth.user()?.last_name }}</div>
              <small>
                @switch (auth.role_id()) {
                  @case (USER_ROLE_OWNER) {
                    <span>(O)</span>
                  }
                  @case (USER_ROLE_MANAGER) {
                    <span>(M)</span>
                  }
                  @case (USER_ROLE_EMPLOYEE) {
                    <span>(E)</span>
                  }
                }
                @if(auth.user()?.positions && auth.user()!.positions!.length > 0) {
                  @if(auth.user()?.positions![0]?.name !== 'default') {
                    {{ auth.user()?.positions![0]?.name }}
                  }
                }
              </small>
            </div>
          </div>
          <p-menu #usermenu [model]="usermenuItems()" [popup]="true"></p-menu>
        </div>
      </div>
    `,
  imports: [
    Button,
    Avatar,
    Menu,
    LocationSwitcher
  ]
}
)
export class TopBar {
  public t = inject(TranslocoService);
  public auth = inject(AuthService);
  public layoutService = inject(LayoutService);

  public usermenuItems = computed<MenuItem[]>(() => [
    {
      label: this.layoutService.isDarkTheme() ? this.t.translate('Light Mode') : this.t.translate('Dark Mode'),
      icon: this.layoutService.isDarkTheme() ? 'pi pi-sun' : 'pi pi-moon',
      command: () => this.layoutService.toggleDarkMode()
    },
    {
      separator: true
    },
    {
      label: this.t.translate('Logout'),
      icon: 'pi pi-sign-out',
      routerLink: '/logout'
    }
  ]);

  protected readonly USER_ROLE_OWNER = USER_ROLE_OWNER;
  protected readonly USER_ROLE_MANAGER = USER_ROLE_MANAGER;
  protected readonly USER_ROLE_EMPLOYEE = USER_ROLE_EMPLOYEE;
}
